import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/metaPixel";

// Module-scoped last-handled path. The base Pixel fires the initial PageView,
// so we record the mount path without firing, and only fire when the path
// actually changes. This is safe under React.StrictMode's double effect
// invocation (the replay sees the same pathname and skips).
let lastTrackedPath = null;

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
    if (lastTrackedPath === null) {
      lastTrackedPath = pathname; // initial load — base pixel already tracked it
      return;
    }
    if (lastTrackedPath === pathname) return; // StrictMode replay / no real nav
    lastTrackedPath = pathname;
    trackPageView();
  }, [pathname]);
  return null;
};
